import { useEffect } from 'react';

const useComponentWillUnmount = (onUnmount) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => () => onUnmount(), []);
};

export default useComponentWillUnmount;
